module.exports = __webpack_public_path__ + "static/media/HCMM451.d3fbe16c.jpg";